import { filterNulls } from "replo-utils/lib/array";

import {
  CHAT_FILE_EXTENSIONS_DISPLAY,
  IMAGE_ACCEPT_FILE_EXTENSIONS,
  IMAGE_EXTENSIONS_DISPLAY,
  VIDEO_ACCEPT_FILE_EXTENSIONS,
  VIDEO_EXTENSIONS_DISPLAY,
} from "./constants";

// NOTE (Kevin, 2025-12-15): Extension to MIME type mapping (single source of truth)
const EXTENSION_TO_MIME: Record<string, string> = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".webp": "image/webp",
  ".svg": "image/svg+xml",
  ".gif": "image/gif",
  ".mp4": "video/mp4",
  ".mov": "video/quicktime",
  ".webm": "video/webm",
};

function formatExtensionsList(extensions: string[]): string {
  if (extensions.length === 0) {
    return "";
  }
  if (extensions.length === 1) {
    const first = extensions[0];
    if (!first) {
      return "";
    }
    return first;
  }
  const last = extensions.at(-1);
  if (!last) {
    return extensions.slice(0, -1).join(", ");
  }
  return `${extensions.slice(0, -1).join(", ")} or ${last}`;
}

export function getExtensionsDisplayForAssetTypes(
  acceptedTypes: ("image" | "video")[] | null,
): string {
  if (!acceptedTypes) {
    return formatExtensionsList(CHAT_FILE_EXTENSIONS_DISPLAY);
  }
  const hasImage = acceptedTypes.includes("image");
  const hasVideo = acceptedTypes.includes("video");
  if (hasImage && hasVideo) {
    return formatExtensionsList(CHAT_FILE_EXTENSIONS_DISPLAY);
  }
  if (hasImage) {
    return formatExtensionsList(IMAGE_EXTENSIONS_DISPLAY);
  }
  if (hasVideo) {
    return formatExtensionsList(VIDEO_EXTENSIONS_DISPLAY);
  }
  return formatExtensionsList(CHAT_FILE_EXTENSIONS_DISPLAY);
}

// NOTE (Kevin, 2025-12-15): Returns the accept types (extensions + MIME types) for the
// given asset types. Used by dropzone components to filter which files can be dropped.
export function getAcceptTypesForAssetTypes(
  acceptedTypes: ("image" | "video")[],
): string[] {
  const extensions: string[] = [];
  const mimeTypes: string[] = [];

  if (acceptedTypes.includes("image")) {
    const imageExtensions = IMAGE_ACCEPT_FILE_EXTENSIONS.filter(
      (ext) => ext !== ".svg",
    );
    extensions.push(...imageExtensions);
    mimeTypes.push(
      ...filterNulls(imageExtensions.map((ext) => EXTENSION_TO_MIME[ext])),
    );
  }
  if (acceptedTypes.includes("video")) {
    extensions.push(...VIDEO_ACCEPT_FILE_EXTENSIONS);
    mimeTypes.push(
      ...filterNulls(
        VIDEO_ACCEPT_FILE_EXTENSIONS.map((ext) => EXTENSION_TO_MIME[ext]),
      ),
    );
  }

  return [...extensions, ...mimeTypes];
}
